<div class="empty-wrapper">
  <img src="../../../../../../../assets/images/empty.svg" alt="Empty"/>
  <h3>Queue Empty</h3>
  <p>
    This queue doesn’t have any {{type}} right now. <br/>
    Refresh or check back later to view {{type}}.
  </p>
</div>
